import { AppShellContent } from "@assetwatch/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useRetainedListSearch } from "../components/navigation/useRetainedListState";
import { assetTreeSearchSchema } from "../lib/assetTreeSearch";
import { AssetTreeScreen } from "../screens/AssetTreeScreen";

export const Route = createFileRoute("/_app/assets/")({
  component: AssetsRoute,
  validateSearch: (search: Record<string, unknown>) =>
    assetTreeSearchSchema.parse(search),
});

function AssetsRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: "/assets" });
  const { restoring } = useRetainedListSearch("assets", search, {
    restore: true,
  });
  if (restoring) return <AppShellContent pending>{null}</AppShellContent>;
  return (
    <AssetTreeScreen
      routeSearch={search}
      onRouteSearchChange={(update) =>
        navigate({
          replace: true,
          search: (previous) => ({ ...previous, ...update }),
        })
      }
    />
  );
}
